import Label from "../Label/Label";

import { DataFieldProps } from "./types";

import "./styles.scss";

const DataField = ({
  value,
  label,
  styles,
  className,
}: DataFieldProps): JSX.Element => {
  console.log("label", value)
  return (
    <div className={`data-field ${className ?? ""}`} style={styles}>
      {label && (
        <>
          <Label required={false} label={label} /> :
        </>
      )}
      {value ? <div className="value">{value}</div> : " -"}
    </div>
  );
};

export default DataField;
